import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
export default ({ isShowSuccess, handleClose }) => {
  return (
    <>
      <Modal
        show={isShowSuccess}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        // show={true}
        className="customePopup"
        dialogClassName="modal-dialog-centered modal-dialog"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <Modal.Title>
              <h1 className="title">SORRY!</h1>
            </Modal.Title>
            <div className="imgHolder">
              <img src="../imgs/sorry.svg" alt="" />
            </div>
            <p>It seems that you have not been whitelisted for this event.</p>
            <Button
              className="btn btn-custom md w--100"
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};
